import React, { useState, useEffect } from 'react';
import styles from './Hero.module.css';
import ScrollRotateImage3D from "../ScrollRotateImage/ScrollRotateImage3D";
import Reviews from "../Reviews/Reviews";
import Brands from "../Brands/Brands";
import Portfolio from "../Portfolio/Portfolio";
import Services from "../Services/Services";
import History from "../History/History";
import About from "../About/About";
import Training from "../Training/Training";

const Hero = () => {
  const [contacts, setContacts] = useState({
    phone: '',
    instagram: '',
    telegram: '',
    address: '',
    phone_visible: true,
    instagram_visible: true,
    telegram_visible: true,
    address_visible: true
  });

  const [historyContent, setHistoryContent] = useState({
    title: 'Моя история',
    paragraphs: ['Загрузка...']
  });

  // Загружаем контакты
  useEffect(() => {
    loadContacts();
    loadHistory();
  }, []);

  const loadContacts = async () => {
    try {
      const response = await fetch('/api/content/contacts');
      const data = await response.json();
      setContacts({
        phone: data.phone || '',
        instagram: data.instagram || '',
        telegram: data.telegram || '',
        address: data.address || '',
        phone_visible: data.phone_visible === 'true',
        instagram_visible: data.instagram_visible === 'true',
        telegram_visible: data.telegram_visible === 'true',
        address_visible: data.address_visible === 'true'
      });
    } catch (error) {
      console.error('Ошибка загрузки контактов:', error);
    }
  };

  const loadHistory = async () => {
    try {
      const response = await fetch('/api/content/history');
      const data = await response.json();
      setHistoryContent({
        title: data.title || 'Моя история',
        paragraphs: [
          data.paragraph_1,
          data.paragraph_2,
          data.paragraph_3
        ].filter(p => p && p.trim())
      });
    } catch (error) {
      console.error('Ошибка загрузки истории:', error);
    }
  };

  return (
      <div>
        <About />
        <Services />
        <Training />
        <Portfolio />
        <Reviews />

        <section id="contacts" className={styles.section}>
          <div className={styles.container}>
            <div className={styles.sectionContent}>
              <h2 className={styles.sectionTitle}>Контакты</h2>
              <div className={styles.sectionText}>
                <p>Свяжитесь для записи или консультации:</p>
                <ul className={styles.contactList}>
                  {contacts.phone_visible && contacts.phone && (
                      <li>
                        <strong>📱 Телефон:</strong>
                        <a href={`tel:${contacts.phone.replace(/\D/g, '')}`}> {contacts.phone}</a>
                      </li>
                  )}
                  {contacts.instagram_visible && contacts.instagram && (
                      <li>
                        <strong>📸 Instagram:</strong>
                        <a href={`https://instagram.com/${contacts.instagram.replace('@', '')}`} target="_blank" rel="noopener noreferrer"> {contacts.instagram}</a>
                      </li>
                  )}
                  {contacts.telegram_visible && contacts.telegram && (
                      <li>
                        <strong>💬 Telegram:</strong>
                        <a href={`https://t.me/${contacts.telegram.replace('@', '')}`} target="_blank" rel="noopener noreferrer"> {contacts.telegram}</a>
                      </li>
                  )}
                  {contacts.address_visible && contacts.address && (
                      <li>
                        <strong>📍 Адрес:</strong>
                        <a
                            href="https://yandex.ru/maps/org/svadebny_stilist/85201298487/?indoorLevel=1&ll=37.782018%2C55.723922&z=17"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.contactLink}
                        >
                          {contacts.address}
                        </a>
                      </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </section>
      </div>
  );
};

export default Hero;